/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Api Documentation
 * Api Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CreateWebhookRequest,
  GetV1WebhookParams,
  PatchV1WebhookByWebhookIdParams,
  PostV1WebhookParams,
  UpdateWebhookRequest,
  WebhookResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 테넌트 요청 없을 시 전체 조회
 * @summary 웹훅 테넌트 조회
 */
export const getV1Webhook = (
  params?: MaybeRef<GetV1WebhookParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WebhookResponse>(
    { url: `/api/v1/webhook`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV1WebhookQueryKey = (params?: MaybeRef<GetV1WebhookParams>) => {
  return ['api', 'v1', 'webhook', ...(params ? [params] : [])] as const;
};

export const getGetV1WebhookQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Webhook>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV1WebhookParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Webhook>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV1WebhookQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Webhook>>> = ({ signal }) =>
    getV1Webhook(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1Webhook>>,
    TError,
    TData
  >;
};

export type GetV1WebhookQueryResult = NonNullable<Awaited<ReturnType<typeof getV1Webhook>>>;
export type GetV1WebhookQueryError = ErrorType<unknown>;

/**
 * @summary 웹훅 테넌트 조회
 */

export function useGetV1Webhook<
  TData = Awaited<ReturnType<typeof getV1Webhook>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV1WebhookParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Webhook>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1WebhookQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 웹훅 등록
 */
export const postV1Webhook = (
  createWebhookRequest: MaybeRef<CreateWebhookRequest>,
  params: MaybeRef<PostV1WebhookParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  createWebhookRequest = unref(createWebhookRequest);
  params = unref(params);

  return customAxiosInstance<WebhookResponse>(
    {
      url: `/api/v1/webhook`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createWebhookRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV1WebhookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1Webhook>>,
    TError,
    { data: BodyType<CreateWebhookRequest>; params: PostV1WebhookParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1Webhook>>,
  TError,
  { data: BodyType<CreateWebhookRequest>; params: PostV1WebhookParams },
  TContext
> => {
  const mutationKey = ['postV1Webhook'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1Webhook>>,
    { data: BodyType<CreateWebhookRequest>; params: PostV1WebhookParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV1Webhook(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1WebhookMutationResult = NonNullable<Awaited<ReturnType<typeof postV1Webhook>>>;
export type PostV1WebhookMutationBody = BodyType<CreateWebhookRequest>;
export type PostV1WebhookMutationError = ErrorType<unknown>;

/**
 * @summary 웹훅 등록
 */
export const usePostV1Webhook = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1Webhook>>,
      TError,
      { data: BodyType<CreateWebhookRequest>; params: PostV1WebhookParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV1Webhook>>,
  TError,
  { data: BodyType<CreateWebhookRequest>; params: PostV1WebhookParams },
  TContext
> => {
  const mutationOptions = getPostV1WebhookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 웹훅 수정
 */
export const patchV1WebhookByWebhookId = (
  webhookId: MaybeRef<number>,
  updateWebhookRequest: MaybeRef<UpdateWebhookRequest>,
  params: MaybeRef<PatchV1WebhookByWebhookIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  webhookId = unref(webhookId);
  updateWebhookRequest = unref(updateWebhookRequest);
  params = unref(params);

  return customAxiosInstance<WebhookResponse>(
    {
      url: `/api/v1/webhook/${webhookId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateWebhookRequest,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV1WebhookByWebhookIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1WebhookByWebhookId>>,
    TError,
    {
      webhookId: number;
      data: BodyType<UpdateWebhookRequest>;
      params: PatchV1WebhookByWebhookIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1WebhookByWebhookId>>,
  TError,
  {
    webhookId: number;
    data: BodyType<UpdateWebhookRequest>;
    params: PatchV1WebhookByWebhookIdParams;
  },
  TContext
> => {
  const mutationKey = ['patchV1WebhookByWebhookId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1WebhookByWebhookId>>,
    {
      webhookId: number;
      data: BodyType<UpdateWebhookRequest>;
      params: PatchV1WebhookByWebhookIdParams;
    }
  > = (props) => {
    const { webhookId, data, params } = props ?? {};

    return patchV1WebhookByWebhookId(webhookId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1WebhookByWebhookIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1WebhookByWebhookId>>
>;
export type PatchV1WebhookByWebhookIdMutationBody = BodyType<UpdateWebhookRequest>;
export type PatchV1WebhookByWebhookIdMutationError = ErrorType<unknown>;

/**
 * @summary 웹훅 수정
 */
export const usePatchV1WebhookByWebhookId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1WebhookByWebhookId>>,
      TError,
      {
        webhookId: number;
        data: BodyType<UpdateWebhookRequest>;
        params: PatchV1WebhookByWebhookIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV1WebhookByWebhookId>>,
  TError,
  {
    webhookId: number;
    data: BodyType<UpdateWebhookRequest>;
    params: PatchV1WebhookByWebhookIdParams;
  },
  TContext
> => {
  const mutationOptions = getPatchV1WebhookByWebhookIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
